import { createStore } from 'vuex'
import popup from '../modules/popup.js'

export default createStore({
  state: {
    staturl: './', //URL сервера статистики
    descrurl: './', // URL ссылки "Полное описание покрытия" в правой части слайдов 
    detailslink: './', // URL ссылки "Подробнее" на слайде 1
    calcSumUrl: '/bitapi/travel_insurance/calc_sum/', // URL api подсчета стоимости страхового полиса
    show: false,
    step: 1,
    countryDateFilled: false,
    stepsfilled: [false, false, false],
    actions: {},
    addonsPrice: 0,
    form: {
      travel: {
        countries: [],
        yearpolis: {
          enabled: false,
          start: false,
          days: false
        },
        already: false,
        dates: '',
        currency: '',
        insurancesum: '',
        resttype: ''
      },
      buyer: {
        name: '',
        birthdate: '',
        tel: '',
        email: ''
      },
      persons: [{
        name: '',
        birthdate: ''
      }],
      policyholder_is_insured: false,
      addons: {
        covid: {
          chosen: true,
          inssum: '',
        },
        med: {
          chosen: true,
          inssum: '',
        },
        accident: {
          chosen: true,
          inssum: '',
        },
        citizen: {
          chosen: false,
          inssum: '',
        },
        losebags: {
          chosen: false,
          inssum: '',
        },
        travelcancel: {
          chosen: false,
          inssum: '',
        },
      }
    },
    loads: [],
  },
  mutations: {
    addLoad(state, val) {
      state.loads = [...state.loads, val]
    },
    removeLoad(state, val) {
      state.loads = state.loads.filter(el => el != val)
    },
    setShow(state, val) {
      state.show = val
    },
    nextStep(state) {
      state.step++
    },
    prevStep(state) {
      state.step--
    },
    setStepFill(state, [n, v]) {
      state.stepsfilled[n] = v
    },
    setcountryDateFilled(state, v) {
      state.countryDateFilled = v
    },
    setAddonsPrice(state, v) {
      state.addonsPrice = v
    },
  },
  getters: {
    formfilled(state) {
      for (let v of state.stepsfilled)
        if (v) return false
      return true
    },
    loading(state) {
      return state.loads.length ? true : false
    },
    personsCount(state) {
      return state.form.persons.length
    }
  },
  actions: {
    nextStep({ commit }) {
      commit('nextStep')
      document.querySelector('.calc').scrollTo({
        top: window.innerWidth > 820? 0 : document.querySelector('.calc__progress').offsetTop - 70,
        behavior: 'smooth'
      })
    },
    prevStep({ commit }) {
      commit('prevStep')
      document.querySelector('.calc').scrollTo({
        top: window.innerWidth > 820? 0 : document.querySelector('.calc__progress').offsetTop - 70,
        behavior: 'smooth'
      })
    },
    pay({ state }) {
      //TODO
      console.log(state.form)
    },
    /* eslint-disable */ //TODO
    callAction({ state }, action) {
      if (state.actions[action]) return
      state.actions[action] = true
      return console.log(action)
      fetch(state.staturl + `&action=${encodeURIComponent(action)}`)
        .then(res => {
          if (!res.ok) throw (res.status)
        })
        .catch(err => console.error(err))
    },
    /* eslint-enable */
    async updateAddonsPrice({state, commit}){
      if (!state.countryDateFilled)
        return
      let sum = 0
      
      await fetch(state.calcSumUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(state.form)
      })
      .then(async res=>{
        if (!res.ok) throw(await res.text())
        return res.json()
      })
      .then(json=> {
        console.log(json)

        if (json.status != 'ok')
          throw(json.message)

        sum = json.policy_cost
        commit('setAddonsPrice', sum)
      })
      .catch(err=>{
        let str = 'Что-то пошло нет так!\n'
        if (typeof(err) == 'string') {
          if (err.match('<title>'))
            str += `Код ошибки: ` + status
          else
            str += err
        }
        console.error(str);
      })
    }
  },
  modules: {
    popup
  }
})
